var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgErrorDelete(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.399,
    height: 11.399,
    viewBox: "0 0 11.399 11.399",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u30B0\\u30EB\\u30FC\\u30D7_24507",
    "data-name": "\\u30B0\\u30EB\\u30FC\\u30D7 24507",
    transform: "translate(10.692 0.707) rotate(90)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\u7DDA_45",
    "data-name": "\\u7DDA 45",
    d: "M9.277,10.692-.707.707.707-.707l9.984,9.984Z",
    transform: "translate(0 0)",
    fill: "#676767"
  }), /*#__PURE__*/React.createElement("path", {
    id: "\\u7DDA_46",
    "data-name": "\\u7DDA 46",
    d: "M.707,10.692-.707,9.277,9.277-.707,10.692.707Z",
    transform: "translate(0 0)",
    fill: "#676767"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorDelete);
export default __webpack_public_path__ + "static/media/error_delete.70bed769543b4a50bfbad16a82cb1f6d.svg";
export { ForwardRef as ReactComponent };